<script setup lang="ts">
import type { TtLocationFragment } from '#graphql-operations'

const props = defineProps<{
  store: TtLocationFragment | null
}>()

const OAwidget = computed(() => {
  let oawidget = `<div
      id="oa_widget"
      class="widget-js"
    /><`
  oawidget += `script type="text/javascript" src="${props.store.adviceUrl?.replace('output/html', 'output/js')}"></`
  oawidget += `script>`
  return oawidget
})
</script>

<template>
  <LazyUiDialog
    v-if="store?.adviceUrl"
    name="store-advice-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('Book your consultation') }}</span>
    </template>

    <UiEmbedFramed :embed-code="OAwidget" />

    <!--
    
    -->
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Store/AdviceDialog.css");
</style>
